import { BuildSkillsVisual } from './BuildSkillsVisual'

export default BuildSkillsVisual
